import Vue from "vue";
import VueRouter from "vue-router";
import * as api from "../base/api";
import { getToken, setMenus, setUserInfo } from "../base/temp-cache";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/login",
    name: "login",
    component: (resolve) =>
      require(["@/components/login-page/redirect-ppn.vue"], resolve),
  },
  {
    path: "/bs-login",
    name: "bs-login",
    component: (resolve) =>
      require(["@/components/login-page/index.vue"], resolve),
  },
  {
    path: "/ppn-login",
    name: "ppn-login",
    component: (resolve) =>
      require(["@/components/login-page/ppnIndex.vue"], resolve),
  },
  {
    path: "/login-to-third",
    name: "login-to-third",
    component: (resolve) =>
      require(["@/components/login-page/loginToThird.vue"], resolve),
  },
  {
    path: "/not-open",
    name: "not-open",
    component: (resolve) => require(["@/components/page/notOpen.vue"], resolve),
  },
];

const router = new VueRouter({
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    // 如果你的連結是帶 # 這種
    // to.hash 就會有值(值就是連結)
    // 例如 #3
    if (to.hash) {
      return {
        // 這個是透過 to.hash 的值來找到對應的元素
        // 照你的 html 來看是不用多加處理這樣就可以了
        // 例如你按下 #3 的連結，就會變成 querySelector('#3')，自然會找到 id = 3 的元素
        selector: to.hash,
      };
    }
  },
  routes,
});

window.onbeforeunload = function () {
  localStorage.removeItem("awardRole");
};

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js